const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    sorting: "default",
    filtering: "all",
};

const filterSlice = createSlice({
    name: "realtedBlogs",
    initialState,
    reducers: {
        setSorting: (state, action) => {
            state.sorting = action.payload;
        },
        setFiltering: (state, action) => {
            state.filtering = action.payload;
        },
    },
});

export const { setSorting, setFiltering } = filterSlice.actions;
export default filterSlice.reducer;
